export default {
  Popover: {
    baseStyle: {
      zIndex: 134,
    },
    variants: {
      responsive: {
        popper: {
          maxW: 'unset',
          width: 'unset',
        },
      },
    },
  },
};
